import { useAppSelector } from "../redux/store";

const GetFooterLinkLabels = () => {
  const customerJourney = useAppSelector((state) => state.customerJourney);
  const { pageText }: any = customerJourney;
  const linkLabels: any = {
    termsOfUse: pageText?.linksMetadata.termsAndConditionsText,
    accesibility: pageText?.linksMetadata.accessibilityText,
    privacy: pageText?.linksMetadata.privacyText,
    protection: pageText?.labelsMetadata.dataProtection,
  };

  return pageText ? linkLabels : {};
};

export default GetFooterLinkLabels;
